import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import Icon from 'Components/Icon';
import React from 'react';
import icons from 'utils/ui/icons';

const StyledIconButton = styled(IconButton)(() => ({
    fontSize: 20
}));

const TableActions = ({ children, loading, fetchData, newEntity }) => {
    return (
        <>
            <>
                {newEntity && (
                    <Tooltip title="New entity">
                        <StyledIconButton onClick={newEntity}>
                            <Icon fixedWidth icon={icons.plus} size="xs"/>
                        </StyledIconButton>
                    </Tooltip>
                )}

                <Tooltip title="Refresh data">
                    <span>
                        <StyledIconButton disabled={loading} onClick={() => fetchData()}>
                            <Icon fixedWidth icon={icons.refresh} size="xs" spin={loading}/>
                        </StyledIconButton>
                    </span>
                </Tooltip>
            </>
            {children}
        </>
    );
};

export default TableActions;
